<template>
  <div class="border baseContentFont mx-1 py-1 text-center">
    {{ customMsg }}
  </div>
</template>

<script>
export default {
  props: {
    customMsg: {
      type: String,
      default: '',
    },
  },
}
</script>

<!-- This component is to display custom message received from the API with similar style/look as of NoRecordFound component -->
